import RouteComponent from './($locale)._index.tsx'
import { GeneralErrorBoundary } from '~/components/error-boundary.tsx'
import { ErrorNotFound } from '~/components/ui/errors/error-not-found.tsx'

export { loader, meta } from './($locale)._index.tsx'

export default RouteComponent

export function ErrorBoundary() {
  return (
    <GeneralErrorBoundary
      statusHandlers={{
        404: () => <ErrorNotFound />,
      }}
    />
  )
}
